import AuthModule from '~/lib/vue/modules/auth';

export default (services, namespace='auth') => {
  return AuthModule.create({services});
};
